import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import { components, contentfulModels } from '@glowforge/ui-common';
import { COLOR_MODES } from 'app/app-constants';

import './shared.less';

const { pageStringsPropType } = contentfulModels;
const { Button } = components;

const SelectMachine = ({
  pageStrings,
  title,
  onSelect,
  assets,
}) => {
  const headerImg = { src: _.get(assets, '[0].file.url'), alt: _.get(assets, '[0].file.title') };
  const mainImg = { src: _.get(assets, '[1].file.url'), alt: _.get(assets, '[1].file.title') };
  return (
    <div className='SelectMachine PageContainer'>
      <div className='header'>
        <img src={headerImg.src} alt={headerImg.alt} />
      </div>
      <div className='title'>
        {title}
      </div>
      <div className='main'>
        <img src={mainImg.src} alt={mainImg.alt} />
      </div>
      <div className='actionButtons'>
        <Button
          className='clearButton orange'
          onClick={() => onSelect(COLOR_MODES.ORANGE)}>
          {pageStrings['orange-setup-button']}
        </Button>
        <Button
          className='clearButton brand'
          onClick={() => onSelect(COLOR_MODES.BRAND)}>
          {pageStrings['brand-setup-button']}
        </Button>
      </div>
    </div>
  );
};

SelectMachine.propTypes = {
  pageStrings: pageStringsPropType.isRequired,
  title: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  assets: PropTypes.arrayOf(PropTypes.object),
};

SelectMachine.defaultProps = {
  title: null,
  subTitle: null,
  assets: {},
};

export default SelectMachine;



// WEBPACK FOOTER //
// ./app/components/setup/select-machine.jsx